var _linearGradient, _path, _mask, _animate, _animate2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBackgroundLineinline = function SvgBackgroundLineinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2200,
    height: 42,
    viewBox: "0 0 2200 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-line_inline_svg__a",
    x1: 0,
    y1: 0,
    x2: "100%",
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ece8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "12.5%",
    stopColor: "#ece8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "32.813%",
    stopColor: "#7d64ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "69.271%",
    stopColor: "#7d64ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "88.021%",
    stopColor: "#ece8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ece8f1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2200 1h-394.5l-20 20h-80l-20-20h-20l-20 20h-120l-20 20h-20l-20-20h-100l-20-20h-40l-20 20h-80l-20-20h-120l-20 20h-80l-20-20h-60l-20 20h-80l-20 20h-20l-20-20h-60l-20-20h-40l-20 20h-80l-20-20h-70l-20 20H318L298 1H0",
    stroke: "#ece8f1"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "background-line_inline_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2200 1h-394.5l-20 20h-80l-20-20h-20l-20 20h-120l-20 20h-20l-20-20h-100l-20-20h-40l-20 20h-80l-20-20h-120l-20 20h-80l-20-20h-60l-20 20h-80l-20 20h-20l-20-20h-60l-20-20h-40l-20 20h-80l-20-20h-70l-20 20H318L298 1H0",
    stroke: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    y: -8,
    width: "100%",
    height: 58,
    fill: "url(#background-line_inline_svg__a)",
    mask: "url(#background-line_inline_svg__b)",
    style: {
      animation: "hero-frame-background-line-animation 9s linear infinite"
    }
  }, _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    from: 0,
    to: 2200,
    dur: "9s",
    repeatCount: "indefinite"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    from: 450,
    to: 450,
    dur: "9s",
    repeatCount: "indefinite"
  }))));
};
export default SvgBackgroundLineinline;